module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-300.928ce4e9.woff";